import store from "../store";


export const subawardSelectors = {
	content: (state = store.getState()) => state.subaward.content,
	subaward: (state = store.getState()) => state.subaward.content.subaward,
	values: (state = store.getState()) => state.subaward.content.values,
	caseInstanceId: (state = store.getState()) => state.subaward.content.subaward.caseInstanceId,
};
